import React, { useState, useEffect, useRef } from 'react'
import { supabase } from '../supabaseClient'
import Swal from 'sweetalert2'
import ReCAPTCHA from 'react-google-recaptcha'
import CaptchaGate from '../components/CaptchaGate'

const bgImage = "https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/Background/Login_BG.png"  
const logoImage = "https://hbylyyfhigscnrozlxqe.supabase.co/storage/v1/object/public/Background/CG%20LOGO.png"   

export default function Login() {
    const [showCaptchaGate, setShowCaptchaGate] = useState(true)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [rememberMe, setRememberMe] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({ ip: null, userAgent: null })
    const [lockoutInfo, setLockoutInfo] = useState(null)
    const [showForgotModal, setShowForgotModal] = useState(false)
    const [forgotEmail, setForgotEmail] = useState("")
    const [forgotOTP, setForgotOTP] = useState(["", "", "", "", "", ""])
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [forgotStep, setForgotStep] = useState(1)
    const [forgotLoading, setForgotLoading] = useState(false)
    const [forgotError, setForgotError] = useState("")
    const [userType, setUserType] = useState("")
    const [captchaValue, setCaptchaValue] = useState(null)
    const recaptchaRef = useRef() 
    const [passwordValidation, setPasswordValidation] = useState({
        length: false,
        upperCase: false,
        number: false,
        special: false
    }) 

  
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080'

    // useEffect(() => {
    //     const lastDebug = localStorage.getItem('lastLoginDebug')
    //     if (lastDebug) {
    //         console.log('=== LAST LOGIN DEBUG INFO ===')
    //         console.log(JSON.parse(lastDebug))
    //         localStorage.removeItem('lastLoginDebug')
    //     }
    // }, [])

    useEffect(() => {
        const verified = sessionStorage.getItem('captchaVerified')
        const timestamp = sessionStorage.getItem('captchaTimestamp')
        
        if (verified === 'true' && timestamp) {
            const thirtyMinutes = 30 * 60 * 1000
            const now = Date.now()
            
            if (now - parseInt(timestamp) < thirtyMinutes) {
                setShowCaptchaGate(false)
            } else {
                sessionStorage.removeItem('captchaVerified')
                sessionStorage.removeItem('captchaTimestamp')
            }
        }
    }, [])

    useEffect(() => {
        const getUserInfo = async () => {
            try {
                const ipResponse = await fetch('https://api.ipify.org?format=json')
                const ipData = await ipResponse.json()
                setUserInfo({ ip: ipData.ip, userAgent: navigator.userAgent })
            } catch (err) {
                console.error('Error getting user info:', err)
                setUserInfo({ ip: 'unknown', userAgent: navigator.userAgent })
            }
        }
        getUserInfo()
    }, [])

    useEffect(() => {
        const savedEmail = localStorage.getItem('rememberedEmail')
        if (savedEmail) {
            setEmail(savedEmail)
            setRememberMe(true)
        }
    }, [])

    useEffect(() => {
        if (lockoutInfo?.is_locked) {
            const timer = setInterval(() => {
                const remaining = Math.ceil((new Date(lockoutInfo.locked_until) - new Date()) / 1000)
                if (remaining <= 0) {
                    setLockoutInfo(null)
                    setError('')
                    clearInterval(timer)
                } else {
                    setError(`Account locked. Please try again in ${remaining} seconds.`)
                }
            }, 1000)
            return () => clearInterval(timer)
        }
    }, [lockoutInfo])

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            .swal2-confirm {
                background-color: #A0826D !important;
                border: none !important;
            }
            .swal2-confirm:hover {
                background-color: #8B5A3C !important;
            }
            .swal2-cancel:hover {
                background-color: #5a5a5a !important;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const handleCaptchaVerified = () => setShowCaptchaGate(false)

    const validatePassword = (password) => {
        const validation = {
            length: password.length >= 8,
            upperCase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
        }
        setPasswordValidation(validation)
        return validation.length && validation.upperCase && validation.number && validation.special
    }

    if (showCaptchaGate) {
        return <CaptchaGate onVerified={handleCaptchaVerified} />
    }

    const logLoginAttempt = async (success, failureReason = null, accountId = null, userType = 'admin') => {
        try {
            await supabase.rpc('log_admin_login_attempt', { 
                p_email: email, 
                p_ip_address: userInfo.ip || 'unknown',
                p_user_agent: userInfo.userAgent || 'unknown',
                p_success: success,
                p_failure_reason: failureReason,
                p_account_id: accountId,
                p_user_type: userType  
            })
        } catch (err) {
            console.error('Error logging login attempt:', err)
        }
    }

    const handleOtpChange = (index, value) => {
        if (!/^\d*$/.test(value)) return
        const newOtp = [...forgotOTP]
        newOtp[index] = value
        setForgotOTP(newOtp)
        if (value && index < 5) {
            document.getElementById(`forgot-otp-${index + 1}`).focus()
        }
    }

    const handleSendForgotOTP = async () => {
        setForgotError("")
        if (!forgotEmail.trim()) {
            await Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill all the missing fields.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            return
        }
        setForgotLoading(true)
        try {
            const { data: otpData, error: otpError } = await supabase.rpc('send_forgot_password_otp', { user_email: forgotEmail })
            console.log('RPC raw response:', JSON.stringify(otpData))
            console.log('RPC error:', JSON.stringify(otpError))

            if (otpError) throw otpError
            const { data: emailData, error: emailError } = await supabase.functions.invoke('send-forgot-otp-v2', { body: { email: forgotEmail, otp: otpData.otp } })
            if (emailError) throw new Error('Failed to send email. Please try again.')

            setUserType(otpData.user_type)
            setForgotStep(2)

            await Swal.fire({ 
                icon: 'success', 
                title: 'Code Sent!', 
                text: 'Check your email for the 6-digit verification code.', 
                confirmButtonText: 'OK', 
                confirmButtonColor: '#A0826D', 
                background: '#f9fafb', 
                customClass: { 
                    popup: 'rounded-2xl', 
                    title: 'text-gray-800 font-bold', 
                    htmlContainer: 'text-gray-600' } 
                })
                
        } catch (err) {
            const isEmailNotFound = err.message?.includes('Email not found')
            const userMessage = isEmailNotFound 
                ? 'No account found with that email address.' 
                : 'Failed to send verification code. Please try again.'

            setForgotError(userMessage)
            await Swal.fire({ 
                icon: isEmailNotFound ? 'warning' : 'error', 
                title: isEmailNotFound ? 'Email Not Found' : 'Error', 
                text: userMessage, 
                confirmButtonText: 'OK', 
                confirmButtonColor: '#A0826D', 
                background: '#f9fafb', 
                customClass: { 
                    popup: 'rounded-2xl', 
                    title: 'text-gray-800 font-bold', 
                    htmlContainer: 'text-gray-600' 
                } 
            })
        } finally {
            setForgotLoading(false)
}
    }

    const handleVerifyForgotOTP = async () => {
        setForgotError("")
        const otpCode = forgotOTP.join("")
        if (!otpCode.trim()) {
            await Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill all the missing fields.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            return
        }
        if (otpCode.length !== 6) { setForgotError("Please enter the complete 6-digit code"); return }
        setForgotLoading(true)
        try {
            const { data, error } = await supabase.rpc('verify_forgot_password_otp', { user_email: forgotEmail, input_otp: otpCode })
            if (error) throw error
            setForgotStep(3)
        } catch(err) {
            setForgotError("Invalid OTP")
            console.log(err.message)
        } finally {
            setForgotLoading(false)
        }
    }

    const handleResetPassword = async () => {
        setForgotError("")
        if (!newPassword.trim() || !confirmPassword.trim()) {
            await Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill all the missing fields.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            return
        }
        if (newPassword !== confirmPassword) { setForgotError("Passwords do not match"); return }
        if (!validatePassword(newPassword)) { setForgotError("Password must meet all requirements"); return }
        setForgotLoading(true)
        try {
            const { error } = await supabase.rpc('update_forgot_password', { user_email: forgotEmail, new_password: newPassword, user_type: userType })
            if (error) throw error
            await Swal.fire({ icon: 'success', title: 'Password Reset Successful!', text: 'Please login with your new password.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            setShowForgotModal(false)
            resetForgotModal()
        } catch (err) {
            setForgotError(err.message || "Failed to reset password")
        } finally {
            setForgotLoading(false)
        }
    }

    const resetForgotModal = () => {
        setForgotEmail("")
        setForgotOTP(["", "", "", "", "", ""])
        setNewPassword("")
        setConfirmPassword("")
        setForgotStep(1)
        setForgotError("")
        setUserType("")
    }

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !forgotOTP[index] && index > 0) {
            document.getElementById(`forgot-otp-${index - 1}`).focus()
        } 
    }

    const handlePaste = (e) => {
        e.preventDefault()
        const pastedData = e.clipboardData.getData('text').slice(0, 6)
        if (!/^\d+$/.test(pastedData)) return
        const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6)
        setForgotOTP(newOtp)
        const lastIndex = Math.min(pastedData.length - 1, 5)
        document.getElementById(`forgot-otp-${lastIndex}`).focus()
    }

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value)
        if (error && error.includes('CAPTCHA')) setError('')
    }

    // const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080'

    const handleLogin = async (e) => {
        e.preventDefault()
        setError('')
        setLoading(true)

        localStorage.removeItem('isAuthenticated')
        localStorage.removeItem('userEmail')
        localStorage.removeItem('userType')
        localStorage.removeItem('mustChangePassword')
        localStorage.removeItem('isAdminAuthenticated')
        localStorage.removeItem('isStaffAuthenticated')
        localStorage.removeItem('staffId')
        localStorage.removeItem('authToken')

        sessionStorage.removeItem('isAuthenticated')
        sessionStorage.removeItem('userEmail')
        sessionStorage.removeItem('userType')
        sessionStorage.removeItem('mustChangePassword')
        sessionStorage.removeItem('isAdminAuthenticated')
        sessionStorage.removeItem('isStaffAuthenticated')
        sessionStorage.removeItem('staffId')
        sessionStorage.removeItem('authToken')

        if (!captchaValue) {
            await Swal.fire({ icon: 'warning', title: 'CAPTCHA Required', text: 'Please complete the CAPTCHA verification.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            setLoading(false)
            return
        }

        if (!email.trim() || !password.trim()) {
            await Swal.fire({ icon: 'warning', title: 'Missing Information', text: 'Please fill all the missing fields.', confirmButtonText: 'OK', confirmButtonColor: '#A0826D', background: '#f9fafb', customClass: { popup: 'rounded-2xl', title: 'text-gray-800 font-bold', htmlContainer: 'text-gray-600' } })
            setLoading(false)
            return
        }

        try {
            // Lockout checks stay exactly as before — these still go through Supabase RPC directly
            const { data: ipLockoutCheck, error: ipLockoutError } = await supabase.rpc('check_ip_lockout', { p_ip_address: userInfo.ip || 'unknown' })
            if (ipLockoutError) throw ipLockoutError
            if (ipLockoutCheck.is_locked) {
                setLockoutInfo(ipLockoutCheck)
                setError(`Too many failed login attempts. Please try again in ${Math.ceil(ipLockoutCheck.seconds_remaining)} seconds.`)
                setLoading(false)
                return
            }

            const { data: lockoutCheck, error: lockoutError } = await supabase.rpc('check_account_lockout', { p_email: email })
            if (lockoutError) throw lockoutError
            if (lockoutCheck.is_locked) {
                setLockoutInfo(lockoutCheck)
                setError(`This account is locked due to multiple failed attempts. Please try again in ${Math.ceil(lockoutCheck.seconds_remaining)} seconds.`)
                setLoading(false)
                return
            }

            const { data: staffLockoutCheck, error: staffLockoutError } = await supabase.rpc('check_staff_account_lockout', { p_email: email })
            if (!staffLockoutError && staffLockoutCheck?.is_locked) {
                setLockoutInfo(staffLockoutCheck)
                setError(`This staff account is locked. Please try again in ${Math.ceil(staffLockoutCheck.seconds_remaining)} seconds.`)
                setLoading(false)
                return
            }

            // Credential verification now happens server-side
            const loginRes = await fetch(`${API_BASE}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password, rememberMe }),
            })
            const loginResult = await loginRes.json()

            if (!loginRes.ok) {
                const { data: ipFailedResult } = await supabase.rpc('handle_failed_login_by_ip', { p_ip_address: userInfo.ip || 'unknown' })
                const { data: staffFailedResult } = await supabase.rpc('handle_failed_staff_login', { p_email: email })
                if (!staffFailedResult) await supabase.rpc('handle_failed_login', { p_email: email })
                await logLoginAttempt(false, loginResult.error || 'Invalid credentials')
                if (recaptchaRef.current) { recaptchaRef.current.reset(); setCaptchaValue(null) }

                if (ipFailedResult?.locked) {
                    setLockoutInfo({ is_locked: true, locked_until: ipFailedResult.locked_until, seconds_remaining: ipFailedResult.lockout_seconds })
                    setError(`Too many failed attempts. This is locked for ${ipFailedResult.lockout_seconds} seconds.`)
                } else if (ipFailedResult?.remaining_attempts !== undefined) {
                    setError(`Invalid email or password. ${ipFailedResult.remaining_attempts} attempt(s) remaining.`)
                } else {
                    setError(loginResult.error || 'Invalid email or password')
                }
                setLoading(false)
                return
            }

            const { token, userType, staffId, mustChangePassword, accountId } = loginResult

            await supabase.rpc('reset_ip_lockout', { p_ip_address: userInfo.ip || 'unknown' })
            if (userType === 'staff') {
                await supabase.rpc('handle_successful_staff_login', { p_email: email })
            } else {
                await supabase.rpc('handle_successful_login', { p_email: email })
            }

            await logLoginAttempt(true, null, accountId, userType)

            if (rememberMe) {
                localStorage.setItem('rememberedEmail', email)
            } else {
                localStorage.removeItem('rememberedEmail')
            }

            const storage = rememberMe ? localStorage : sessionStorage
            storage.setItem('authToken', token)
            storage.setItem('isAuthenticated', 'true')
            storage.setItem('userEmail', email)
            storage.setItem('userType', userType)
            storage.setItem('mustChangePassword', String(mustChangePassword))

            
            if (userType === 'admin') storage.setItem('isAdminAuthenticated', 'true')
            else if (userType === 'staff') {
                storage.setItem('isStaffAuthenticated', 'true')
                if (staffId) storage.setItem('staffId', staffId)
            }

            localStorage.setItem('lastLoginDebug', JSON.stringify({
                timestamp: new Date().toISOString(),
                userType,
                mustChangePassword,
                sessionData: {
                    isAuthenticated: sessionStorage.getItem('isAuthenticated'),
                    userEmail: sessionStorage.getItem('userEmail'),
                    userType: sessionStorage.getItem('userType'),
                    mustChangePassword: sessionStorage.getItem('mustChangePassword'),
                }
            }))

            if (userType === 'admin') {
                window.location.href = mustChangePassword ? '/setup-admin' : '/dashboard'
            } else if (userType === 'staff') {
                
                try {
                    const { warmStaffSession } = await import('../offline/posOfflineHelpers')
                    await warmStaffSession(navigator.onLine)
                } catch (err) {
                    console.error('Session warm-up failed:', err)
                }

                window.location.href = mustChangePassword ? '/staff-setup' : '/staff-dashboard'
            }

        } catch (err) {
            console.error('Login error:', err)
            setError('An error occurred during login. Please try again.')
            if (recaptchaRef.current) { recaptchaRef.current.reset(); setCaptchaValue(null) }
            setLoading(false)
        }
    }
    


    const EyeOpen = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"/><path d="M2 12c1.6-4.097 5.336-7 10-7s8.4 2.903 10 7c-1.6 4.097-5.336 7-10 7s-8.4-2.903-10-7"/></g></svg>
    )
    const EyeClosed = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a13.4 13.4 0 0 0 3 2.685M21 10a13.4 13.4 0 0 1-3 2.685m-8 1.624L9.5 16.5m.5-2.19a10.6 10.6 0 0 0 4 0m-4 0a11.3 11.3 0 0 1-4-1.625m8 1.624l.5 2.191m-.5-2.19a11.3 11.3 0 0 0 4-1.625m0 0l1.5 1.815M6 12.685L4.5 14.5"/></svg>
    )

    const inputCls = "w-full pl-10 pr-4 py-2.5 rounded-lg text-sm text-gray-800 bg-white border border-gray-200 focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none disabled:opacity-50 disabled:cursor-not-allowed"

    return (
        <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
            <img
                src={bgImage}
                alt=""
                fetchpriority="high"
                loading="eager"
                className="absolute inset-0 w-full h-full object-cover -z-10"
            />
            {/* Login card */}
            <div className="relative z-10 w-full max-w-xl mx-4">
                <div
                    className="rounded-2xl shadow-2xl px-5 sm:px-8 py-8 sm:py-10"                    style={{ background: 'rgba(30, 20, 15, 0.85)', backdropFilter: 'blur(12px)', border: '1px solid rgba(255,255,255,0.08)' }}
                >
                    {/* Logo */}
                    <div className="flex flex-col items-center mb-7">
                        <img
                            src={logoImage}
                            alt="Coffee Gus·To Logo"
                            className="w-1/3 h-1/3 object-contain select-none mb-3"
                            draggable={false}
                        />
                        <h1 className="text-2xl font-bold tracking-wider text-white">Welcome Back</h1>
                        <p className="text-sm text-gray-400 mt-1">Please log in to your account</p>
                    </div>

                    {/* Error banner */}
                    {error && (
                        <div className={`mb-4 px-4 py-3 rounded-lg text-sm ${lockoutInfo?.is_locked ? 'bg-orange-500/20 border border-orange-500/40 text-orange-300' : 'bg-red-500/20 border border-red-500/40 text-red-300'}`}>
                            {error}
                        </div>
                    )}

                    <div className="space-y-5">
                        {/* Email */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-300 mb-1.5">Email Address</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg>
                                </span>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleLogin(e)}
                                    placeholder="admin@coffeeshop.com"
                                    disabled={lockoutInfo?.is_locked}
                                    className={inputCls}
                                    required
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-300 mb-1.5">Password</label>
                            <div className="relative">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                                </span>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleLogin(e)}
                                    placeholder="Enter your Password"
                                    disabled={lockoutInfo?.is_locked}
                                    className={inputCls}
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-200 transition"
                                    disabled={lockoutInfo?.is_locked}
                                >
                                    {showPassword ? <EyeOpen /> : <EyeClosed />}
                                </button>
                            </div>
                        </div>

                        {/* Remember me / Forgot password */}
                        <div className="flex items-center justify-between">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                    className="w-4 h-4 rounded accent-orange-500"
                                    disabled={lockoutInfo?.is_locked}
                                />
                                <span className="text-sm text-gray-300">Remember Me</span>
                            </label>
                            <button
                                type="button"
                                onClick={() => setShowForgotModal(true)}
                                className="text-sm text-gray-300 hover:text-orange-400 transition"
                            >
                                Forgot Password?
                            </button>
                        </div>

                        {/* reCAPTCHA */}
                        <div className="flex justify-center overflow-x-auto">                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY}
                                onChange={handleCaptchaChange}
                                onExpired={() => setCaptchaValue(null)}
                                theme="dark"
                            />
                        </div>

                        {/* Login button */}
                        <button
                            onClick={handleLogin}
                            disabled={loading || lockoutInfo?.is_locked || !captchaValue}
                            className="w-full py-3 rounded-lg font-semibold text-white transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ background: loading || lockoutInfo?.is_locked ? '#888' : 'linear-gradient(135deg, #ff7b4b, #FF6F3C)' }}
                            onMouseEnter={(e) => { if (!loading && !lockoutInfo?.is_locked && captchaValue) e.currentTarget.style.background = 'linear-gradient(135deg, #ff5722, #e64a19)' }}
                            onMouseLeave={(e) => { if (!loading && !lockoutInfo?.is_locked && captchaValue) e.currentTarget.style.background = 'linear-gradient(135deg, #ff7b4b, #FF6F3C)' }}
                        >
                            {loading ? 'Logging in...' : lockoutInfo?.is_locked ? 'Account Locked' : 'Login'}
                        </button>
                    </div>

                    {/* Security notice */}
                    <div className="mt-6 flex items-start gap-2 text-xs text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="flex-shrink-0 mt-0.5"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                        <p>This is a secure admin area. Only authorized personnel with valid credentials can access this system. All login attempts are logged and monitored.</p>
                    </div>
                    <p className="mt-3 text-center text-xs text-gray-500">Need access? Contact your system administrator</p>
                </div>
            </div>

            {/* Forgot Password Modal */}
            {showForgotModal && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
                    onClick={(e) => { if (e.target === e.currentTarget) { setShowForgotModal(false); resetForgotModal() } }}
                >
                    <div
                        className="relative w-full max-w-md rounded-2xl shadow-2xl px-5 sm:px-8 py-6 sm:py-8"                        style={{ background: 'rgba(30, 20, 15, 0.95)', backdropFilter: 'blur(16px)', border: '1px solid rgba(255,255,255,0.10)' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-center justify-between mb-5">
                            <h2 className="text-xl font-bold text-white">
                                {forgotStep === 1 && 'Reset Password'}
                                {forgotStep === 2 && 'Verify Code'}
                                {forgotStep === 3 && 'New Password'}
                            </h2>
                            <button onClick={() => { setShowForgotModal(false); resetForgotModal() }} className="text-gray-400 hover:text-white transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                            </button>
                        </div>

                        {forgotError && (
                            <div className="bg-red-500/20 border border-red-500/40 text-red-300 px-4 py-3 rounded-lg mb-4 text-sm">
                                {forgotError}
                            </div>
                        )}

                        {/* Step 1 – Enter email */}
                        {forgotStep === 1 && (
                            <div className="space-y-4">
                                <p className="text-sm text-gray-400">Enter your email address and we'll send you a verification code to reset your password.</p>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-300 mb-1.5">Email Address</label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg>
                                        </span>
                                        <input
                                            type="email"
                                            value={forgotEmail}
                                            onChange={(e) => setForgotEmail(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleSendForgotOTP()}
                                            placeholder="you@example.com"
                                            className={inputCls}
                                            required
                                        />
                                    </div>
                                </div>
                                <button onClick={handleSendForgotOTP} disabled={forgotLoading} className="w-full bg-[#FF6F3C] hover:bg-[#FE4E10] text-white font-semibold py-3 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                                    {forgotLoading ? 'Sending...' : 'Send Verification Code'}
                                </button>
                                <button onClick={() => { setShowForgotModal(false); resetForgotModal() }} className="w-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 font-semibold py-3 rounded-lg transition duration-200">
                                    Cancel
                                </button>
                            </div>
                        )}

                        {/* Step 2 – Enter OTP */}
                        {forgotStep === 2 && (
                            <div className="space-y-4">
                                <p className="text-sm text-white">Enter the 6-digit verification code sent to <span className="font-semibold text-white">{forgotEmail}</span></p>
                                <div className="flex gap-1.5 sm:gap-2 justify-center mb-2">                                    {forgotOTP.map((digit, index) => (
                                        <input
                                            key={index}
                                            id={`forgot-otp-${index}`}
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(index, e)}
                                            onPaste={handlePaste}
                                            autoComplete="off"
                                            className="w-10 h-12 sm:w-12 sm:h-14 text-center text-xl sm:text-2xl font-bold bg-white/10 border-2 border-white/20 text-white rounded-lg focus:ring-2 focus:ring-orange-400 focus:border-orange-400 outline-none transition"                                            required
                                        />
                                    ))}
                                </div>
                                <button onClick={handleVerifyForgotOTP} disabled={forgotLoading} className="w-full bg-[#ff7b4b] hover:bg-[#FE4E10] text-white font-semibold py-3 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                                    {forgotLoading ? 'Verifying...' : 'Verify Code'}
                                </button>
                                <button onClick={() => { setShowForgotModal(false); resetForgotModal() }} className="w-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 font-semibold py-3 rounded-lg transition duration-200">
                                    Cancel
                                </button>
                            </div>
                        )}

                        {/* Step 3 – New password */}
                        {forgotStep === 3 && (
                            <div className="space-y-4">
                                <p className="text-sm text-white">Create a new password. Make sure it meets all the requirements below.</p>
                                {/* New password */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-300 mb-1.5">New Password</label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                                        </span>
                                        <input type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={(e) => { setNewPassword(e.target.value); validatePassword(e.target.value) }} placeholder="Enter new password" className={inputCls} required />
                                        <button type="button" onClick={() => setShowNewPassword(!showNewPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-200 transition">
                                            {showNewPassword ? <EyeOpen /> : <EyeClosed />}
                                        </button>
                                    </div>
                                </div>
                                {/* Confirm password */}
                                <div>
                                    <label className="block text-sm font-semibold text-gray-300 mb-1.5">Confirm Password</label>
                                    <div className="relative">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 16c0-2.828 0-4.243.879-5.121C3.757 10 5.172 10 8 10h8c2.828 0 4.243 0 5.121.879C22 11.757 22 13.172 22 16s0 4.243-.879 5.121C20.243 22 18.828 22 16 22H8c-2.828 0-4.243 0-5.121-.879C2 20.243 2 18.828 2 16Z"/><path strokeLinecap="round" d="M6 10V8a6 6 0 1 1 12 0v2"/></g></svg>
                                        </span>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            onKeyPress={(e) => e.key === 'Enter' && handleResetPassword()}
                                            placeholder="Confirm new password"
                                            className={`w-full pl-10 pr-12 py-3 rounded-lg text-black placeholder-white outline-none transition bg-white border-2 focus:ring-2 focus:ring-orange-400/30 ${
                                                confirmPassword && confirmPassword === newPassword ? 'border-green-500' : confirmPassword && confirmPassword !== newPassword ? 'border-red-500' : 'border-white/20 focus:border-orange-400'
                                            }`}
                                            required
                                        />
                                        <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-200 transition">
                                            {showConfirmPassword ? <EyeOpen /> : <EyeClosed />}
                                        </button>
                                    </div>
                                    {confirmPassword && (
                                        <p className={`text-xs mt-1 ${confirmPassword === newPassword ? 'text-green-400' : 'text-red-400'}`}>
                                            {confirmPassword === newPassword ? 'Passwords match' : 'Passwords do not match'}
                                        </p>
                                    )}
                                </div>

                                {/* Password requirements */}
                                {newPassword && (
                                    <div className="grid grid-cols-2 gap-2 p-3 rounded-lg bg-white border border-white">
                                        {[
                                            { key: 'length', label: '8+ characters' },
                                            { key: 'upperCase', label: 'Uppercase letter' },
                                            { key: 'number', label: 'Number' },
                                            { key: 'special', label: 'Special character' },
                                        ].map(({ key, label }) => (
                                            <div key={key} className="flex items-center gap-1.5 text-xs">
                                                {passwordValidation[key] ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="text-green-400 flex-shrink-0"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"/></svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="text-gray-500 flex-shrink-0"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2"/></svg>
                                                )}
                                                <span className={passwordValidation[key] ? 'text-green-400' : 'text-gray-500'}>{label}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <button onClick={handleResetPassword} disabled={forgotLoading} className="w-full bg-[#ff7b4b] hover:bg-[#FE4E10] text-white font-semibold py-3 rounded-lg transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                                    {forgotLoading ? 'Resetting...' : 'Reset Password'}
                                </button>
                                <button onClick={() => { setShowForgotModal(false); resetForgotModal() }} className="w-full border border-white/20 text-gray-400 hover:text-white hover:border-white/40 font-semibold py-3 rounded-lg transition duration-200">
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}